import { useEffect } from "react"
import { createPopup } from "@typeform/embed"
import { EMRTypeID, FileIntentRequest, GAHTFHTConsent_ID, GAHTIntake_ID, GAHTMHTConsent_ID } from "@imago/model"
import { declareIntent, ImagoIntentMutation, useConfig, useDeclareImagoIntent, useGAHTConsented, useGAHTIntaken, useTfFile_internal } from "../api.ts"
export { useGAHTConsented, useGAHTIntaken }

export function useGAHTIntake() {
	return useDeclareImagoIntent({verb: 'file', formID: GAHTIntake_ID})
}

function useFake(formID: EMRTypeID) {
	const config = useConfig()
	const tf_file = useTfFile_internal()
	return config.testMode ? {
		mutateAsync: async () => {
			const intent = await declareIntent({verb: 'file', formID})
			await tf_file.mutateAsync({form: intent.tf_secret_v2.formID, response: '__sandbox'})
		},
		isPending: tf_file.isPending,
	} : null
}

export function useFakeGAHTIntake() {
	return useFake(GAHTIntake_ID)
}

export function useFHTConsent() {
	return useDeclareImagoIntent({verb: 'file', formID: GAHTFHTConsent_ID})
}

export function useMHTConsent() {
	return useDeclareImagoIntent({verb: 'file', formID: GAHTMHTConsent_ID})
}

export function useFakeFHTConsent() {
	return useFake(GAHTFHTConsent_ID)
}

export function useFakeMHTConsent() {
	return useFake(GAHTMHTConsent_ID)
}

export function FormDialog({mutation}: {
	mutation: ImagoIntentMutation<FileIntentRequest>
}) {
	const config = useConfig()
	const tf_file = useTfFile_internal()

	async function showModal() {
		const tf = (await mutation.intent!).tf_secret_v2

		let resolveDone: ((v: undefined) => void) | undefined = undefined
		const done = new Promise((resolve, reject) => {
			resolveDone = resolve
		})

		const popup = createPopup(tf.formID, {
			hidden: tf.hidden,
			enableSandbox: config.testMode,
			onSubmit: ev => tf_file.mutate({form: tf.formID, response: ev.responseId}, {
				onSettled: () => resolveDone ? resolveDone(undefined) : undefined
			}),
			onEndingButtonClick: async ev => {
				await done
				popup.close()
			},
			onClose: () => {
				mutation.cancel!()
			}
		})
		popup.open()
	}
	function close() {

	}

	useEffect(() => {
		if (mutation.isPending) showModal()
		else close()
	}, [mutation.isPending])

	return <></>
}
